import MvModal from "./MvModal";
import {MvMessageModal} from "./MvMessageModal";
import {MvRoomModal} from "./MvRoomModal";
import {MvResortModal} from "./MvResortModal";
import {MvErrorModal} from "./MvErrorModal";
import {MvAddWaitlistModal} from "./MvAddWaitlistModal";

export {
  MvModal,
  MvMessageModal,
  MvRoomModal,
  MvResortModal,
  MvErrorModal,
  MvAddWaitlistModal
};

export default MvModal;
